import { backgroundColor, height, textAlign, textColor, twCls } from 'style';

export const emptySpaceStyle = twCls(
  backgroundColor('bg-white'),
  textColor('text-black'),
  textAlign('text-center'),
);

export const contentStyle = twCls(height('h-4'), backgroundColor('bg-grey-50'));
